import { Button, Result } from "antd";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { roles } from "../config/roles";
import backImg from "../assets/backImg.png";
import styles from "./layoutstyle.module.css";
import Storage from "../utills/AsyncStorage";


export const HomeLayout = () => {
  const isLogin = useSelector((state) => state.AuthReducer.isLogin);
  
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");

  const navigate = useNavigate();

  if (isLogin == true) {
    if (role == roles.client) {
      return <Navigate to={"/clientHome"} />;
    } else if (role == roles.guest) {
      return <Navigate to={"/guestHome"} />;
    } else if (role == roles.vendor ||role == roles.staff ) {
      return <Navigate to={"/vendorHome"} />;
    }else if (role == roles.coHost) {
      return <Navigate to={"/events"} />;
    }
  }
  return (
    <div className={styles.publiclayoutContainer}>
      <Outlet />
    </div>
  );
};

export const RolesLayout = ({ roles }) => {
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");

  console.log("role", role, roles?.includes(role), roles);
  const navigate = useNavigate();
  if (!roles?.includes(role)) {
    return (
      <Result
        style={{ width: "100%", padding: "0px !important" }}
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        }
      />
    );
  }
  return (
    <div>
      <Outlet />
    </div>
  );
};
